import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

const LANGUAGES = [
  { code: 'en', label: 'English', flag: '🇺🇸' },
  { code: 'zh', label: '中文', flag: '🇨🇳' },
  { code: 'vi', label: 'Tiếng Việt', flag: '🇻🇳' },
];

function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    if (!isOpen) return undefined;
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) setIsOpen(false);
    };
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') setIsOpen(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [isOpen]);

  const current = LANGUAGES.find((item) => item.code === i18n.language) || LANGUAGES[0];

  const handleSelect = (code) => {
    i18n.changeLanguage(code);
    setIsOpen(false);
  };

  return (
    <div className="language-switcher" ref={containerRef}>
      <button type="button" className="language-switcher-btn" onClick={() => setIsOpen((open) => !open)} aria-label="Change language" title="Change language">
        <span aria-hidden="true">{current.flag}</span>
        <span className="language-switcher-caret" aria-hidden="true">▾</span>
      </button>
      {isOpen && (
        <div className="language-switcher-panel">
          {LANGUAGES.map((item) => (
            <button
              type="button"
              key={item.code}
              className={`language-switcher-option${item.code === current.code ? ' active' : ''}`}
              onClick={() => handleSelect(item.code)}
            >
              <span aria-hidden="true">{item.flag}</span>
              <span>{item.label}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export default LanguageSwitcher;
